export default function () {
  return {
    dateBeforePicker: false,
    dateAfterPicker: false,
    filters: {
      'date[before]': '',
      'date[after]': '',
      plan: '',
    },
    reports: [],
    chart: {
      options: {
        chart: {
          id: 'subscriptions',
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value.toFixed(1)
            },
          },
        },
      },
      series: [{
        name: 'Assinaturas',
        data: [],
      }],
    },
  }
}
